//路由表
import Prescription from '@/views/prescription/prescription.vue'
import ChoiceYC from '@/views/choiceYC/choiceYC.vue'
import NewsMedia from '@/views/newsMedia/newsMedia.vue'
import AboutYC from '@/views/aboutYC/aboutYC.vue'
import ObligationYC from '@/views/obligationYC/obligationYC.vue'
import ServiceAdvantage from '@/views/choiceYC/serviceAdvantage/serviceAdvantage.vue'
import JoinUs from "@/views/joinUs/joinUs.vue";

export default [
    {
        path: '/',
        redirect: '/choiceYC',
    },
    {
        path: '/choiceYC',
        name: 'choiceYC',
        component: ChoiceYC,
    },
    {
        path: '/prescription',
        name: 'prescription',
        component: Prescription,
    },
    {
        path: '/newsMedia',
        name: 'newsMedia',
        component: NewsMedia,
    },
    {
        path: '/aboutYC',
        name: 'aboutYC',
        component: AboutYC,
    },
    {
        path: '/obligationYC',
        name: 'obligationYC',
        component: ObligationYC,
    },
    {
        path: '/serviceUpgrade',
        name: 'serviceUpgrade',
        component: ServiceAdvantage,
    },
    {
        path: '/joinUs',
        name: 'joinUs',
        component: JoinUs
    }
]
